/* MAYAS wishlist engine (W1, 2026-09-24).
   Loaded deferred on every page by snippets/wishlist-core.liquid.
   - Device list: localStorage, first-party cookie fallback.
   - Logged-in customers: synced through the app proxy /apps/wishlist (when it exists;
     device-only otherwise). Server = source of truth after the first merge on a device.
   - Events via window.themeTrack; Klaviyo 'Added to Wishlist' for identified, consented visitors.
   Public API: window.MayasWishlist.{items, has, add, remove, count, onChange}. */
(function () {
  'use strict';
  if (window.MayasWishlist) return;

  var KEY = 'mayas_wishlist_v1';
  var COOKIE = 'mayas_wl';
  var MAX_ITEMS = 100;
  var COOKIE_MAX = 3600;
  var SS_SYNC = 'mayas_wl_sync';

  var cfg = {};
  try {
    var cfgEl = document.getElementById('mayas-wishlist-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}') || {};
  } catch (e) { cfg = {}; }
  var customerId = cfg.customerId ? String(cfg.customerId) : '';
  var proxy = cfg.proxy || '/apps/wishlist';

  /* ---------- storage ---------- */
  var lsOk = (function () {
    try {
      var k = '__mayas_wl_t';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) { return false; }
  })();

  function readCookie() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }

  function writeCookie(state) {
    try {
      var copy = { v: 1, cid: state.cid || null, items: state.items.slice() };
      var val = encodeURIComponent(JSON.stringify(copy));
      while (val.length > COOKIE_MAX && copy.items.length) {
        copy.items.shift();
        val = encodeURIComponent(JSON.stringify(copy));
      }
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = COOKIE + '=' + val + '; Max-Age=31536000; Path=/; SameSite=Lax' + secure;
    } catch (e) {}
  }

  function sanitizeItems(list) {
    var out = [];
    var seen = {};
    if (!list || !list.length) return out;
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (!it || typeof it.h !== 'string' || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(it.h) || seen[it.h]) continue;
      seen[it.h] = true;
      out.push({
        h: it.h,
        p: it.p ? String(it.p).replace(/\D/g, '') : null,
        v: it.v ? String(it.v).replace(/\D/g, '') : null,
        s: it.s ? String(it.s).slice(0, 24) : null,
        t: Number(it.t) || 0
      });
    }
    out.sort(function (a, b) { return a.t - b.t; });
    while (out.length > MAX_ITEMS) out.shift();
    return out;
  }

  function load() {
    var raw = null;
    if (lsOk) {
      try { raw = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { raw = null; }
    } else {
      raw = readCookie();
    }
    return { v: 1, cid: raw && raw.cid ? String(raw.cid) : null, items: sanitizeItems(raw && raw.items) };
  }

  var state = load();

  function persist() {
    if (lsOk) {
      try { window.localStorage.setItem(KEY, JSON.stringify(state)); return; } catch (e) {}
    }
    writeCookie(state);
  }

  /* ---------- UI sync (header count + hearts) ---------- */
  var listeners = [];

  function paint() {
    var n = state.items.length;
    var counts = document.querySelectorAll('[data-mayas-wishlist-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = n > 99 ? '99+' : String(n);
      counts[i].hidden = n === 0;
    }
    var links = document.querySelectorAll('[data-mayas-wishlist-link]');
    for (var j = 0; j < links.length; j++) {
      var base = links[j].getAttribute('data-label') || '';
      links[j].setAttribute('aria-label', n ? base + ' (' + n + ')' : base);
    }
    var hearts = document.querySelectorAll('[data-mayas-wishlist-heart]');
    for (var k = 0; k < hearts.length; k++) {
      var on = has(hearts[k].getAttribute('data-handle'));
      hearts[k].setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = hearts[k].getAttribute(on ? 'data-label-remove' : 'data-label-add');
      if (lbl) hearts[k].setAttribute('aria-label', lbl);
    }
  }

  function changed() {
    persist();
    paint();
    for (var i = 0; i < listeners.length; i++) {
      try { listeners[i](items()); } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('mayas-wishlist:change', { detail: { items: items() } }));
    } catch (e) {}
    queuePush();
  }

  /* ---------- core API ---------- */
  function items() { return state.items.slice().reverse(); }
  function has(handle) {
    for (var i = 0; i < state.items.length; i++) if (state.items[i].h === handle) return true;
    return false;
  }
  function count() { return state.items.length; }

  function add(item) {
    if (!item || !item.h) return false;
    var clean = sanitizeItems([{ h: item.h, p: item.p, v: item.v, s: item.s, t: Date.now() }]);
    if (!clean.length) return false;
    state.items = state.items.filter(function (x) { return x.h !== clean[0].h; });
    state.items.push(clean[0]);
    while (state.items.length > MAX_ITEMS) state.items.shift();
    changed();
    return true;
  }

  function remove(handle) {
    var before = state.items.length;
    state.items = state.items.filter(function (x) { return x.h !== handle; });
    if (state.items.length !== before) { changed(); return true; }
    return false;
  }

  function get(handle) {
    for (var i = 0; i < state.items.length; i++) if (state.items[i].h === handle) return state.items[i];
    return null;
  }

  /* ---------- account sync via app proxy ---------- */
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function syncOff() { return ssGet(SS_SYNC) === 'off'; }

  function proxyFetch(method, body) {
    var opts = { method: method, credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(proxy + '/items', opts).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      if (ct.indexOf('application/json') === -1) {
        ssSet(SS_SYNC, 'off');
        throw new Error('wishlist sync unavailable');
      }
      return r.json().then(function (data) {
        if (!r.ok || !data || data.ok !== true) throw new Error('wishlist sync error ' + r.status);
        return data;
      });
    });
  }

  function adopt(serverItems) {
    state.items = sanitizeItems(serverItems);
    state.cid = customerId;
    persist();
    paint();
    for (var i = 0; i < listeners.length; i++) {
      try { listeners[i](items()); } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('mayas-wishlist:change', { detail: { items: items(), source: 'sync' } }));
    } catch (e) {}
  }

  var pushTimer = null;
  var syncing = null;

  function queuePush() {
    if (!customerId || syncOff()) return;
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      var mode = state.cid === customerId ? 'replace' : 'merge';
      proxyFetch('POST', { mode: mode, items: state.items }).then(function (data) {
        if (mode === 'merge') adopt(data.items);
        else if (state.cid !== customerId) { state.cid = customerId; persist(); }
      }).catch(function () {});
    }, 600);
  }

  function initialSync() {
    if (!customerId) {
      if (state.cid) { state.cid = null; persist(); }
      return Promise.resolve(false);
    }
    if (syncOff()) return Promise.resolve(false);
    if (ssGet(SS_SYNC) === customerId && state.cid === customerId) return Promise.resolve(true);
    var firstOnDevice = state.cid !== customerId;
    var req = firstOnDevice
      ? proxyFetch('POST', { mode: 'merge', items: state.items })
      : proxyFetch('GET');
    syncing = req.then(function (data) {
      adopt(data.items);
      ssSet(SS_SYNC, customerId);
      return true;
    }).catch(function () { return false; });
    return syncing;
  }

  /* ---------- events ---------- */
  function track(name, props) {
    try { if (typeof window.themeTrack === 'function') window.themeTrack(name, props); } catch (e) {}
  }

  function klaviyoAdded(props) {
    var k = window.klaviyo;
    if (!k || typeof k.push !== 'function') return;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function' || cp.marketingAllowed() !== true) return;
    } catch (e) { return; }
    var idp;
    try { idp = typeof k.isIdentified === 'function' ? k.isIdentified() : null; } catch (e) { idp = null; }
    Promise.resolve(idp).then(function (identified) {
      if (!identified) return;
      k.push(['track', 'Added to Wishlist', {
        ProductName: props.product_title || '',
        ProductID: props.product_id || '',
        ProductHandle: props.product_handle || '',
        VariantID: props.variant_id || '',
        Size: props.size || '',
        Price: props.price,
        Currency: props.currency || '',
        URL: props.url || '',
        ImageURL: props.image_url || '',
        Source: props.source || ''
      }]);
    }).catch(function () {});
  }

  /* ---------- hearts (event delegation, works for late-rendered hearts) ---------- */
  function activeSize() {
    var el = document.querySelector('.mayas-v3-size--active[data-variant-id]') ||
             document.querySelector('.mayas-v3-size[aria-pressed="true"][data-variant-id]');
    if (!el) return null;
    return {
      id: el.getAttribute('data-variant-id'),
      title: el.getAttribute('data-variant-title') || (el.textContent || '').trim(),
      price: parseInt(el.getAttribute('data-variant-price'), 10)
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mayas-wishlist-heart]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var source = btn.getAttribute('data-source') || 'pdp';
    var size = (source === 'pdp' || source === 'sticky') ? activeSize() : null;
    var cents = size && !isNaN(size.price) ? size.price : parseInt(btn.getAttribute('data-price'), 10);
    var props = {
      product_id: btn.getAttribute('data-product-id') || null,
      product_handle: handle,
      product_title: btn.getAttribute('data-title') || '',
      variant_id: size ? size.id : null,
      size: size ? size.title : null,
      price: isNaN(cents) ? null : cents / 100,
      currency: btn.getAttribute('data-currency') || null,
      source: source,
      url: btn.getAttribute('data-url') || '',
      image_url: btn.getAttribute('data-image') || ''
    };
    if (has(handle)) {
      remove(handle);
      props.item_count = count();
      track('wishlist_removed', stripPrivate(props));
    } else {
      add({ h: handle, p: props.product_id, v: props.variant_id, s: props.size });
      props.item_count = count();
      track('wishlist_added', stripPrivate(props));
      klaviyoAdded(props);
    }
  });

  function stripPrivate(p) {
    return {
      product_id: p.product_id, product_handle: p.product_handle, variant_id: p.variant_id,
      size: p.size, price: p.price, currency: p.currency, source: p.source, item_count: p.item_count
    };
  }

  function onChange(fn) { if (typeof fn === 'function') listeners.push(fn); }

  window.MayasWishlist = {
    items: items,
    has: has,
    get: get,
    add: add,
    remove: remove,
    count: count,
    onChange: onChange,
    track: track,
    loggedIn: !!customerId,
    ready: null
  };

  function boot() {
    paint();
    window.MayasWishlist.ready = initialSync();
    try { document.dispatchEvent(new CustomEvent('mayas-wishlist:ready')); } catch (e) {}
  }

  /* Other tabs of the same shop: keep count + hearts in step. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    state = load();
    paint();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
